/* SK本舗 カタログ請求ハブ（sections/sk-catalog-request.liquid）用スクリプト
 * - URL クエリ → Tally hidden fields（passthrough_params で許可したキーのみ）
 * - 選択中の機種の表示
 * - Tally.FormSubmitted（postMessage・origin と送信元 iframe を検証）→ 送信後パネル（機種→PDF 照合）＋ 計測
 * - 計測に自由入力文字列や個人情報は送らない（台帳に一致した機種名・区分の定義済み値のみ）
 * 文言・設定は全て section の data-* 属性から受け取る（Liquid/JS にベタ書きしない）
 * テーマエディタの再描画（shopify:section:load）でも再初期化する
 */
(function () {
  var KEY_RE = /^[a-z0-9_-]{1,32}$/;
  var KUBUN = ['個人', '法人', '教育機関'];
  var SOURCES = ['hub', 'catalog-card', 'catalog-selector'];
  var hasOwn = function (o, k) { return Object.prototype.hasOwnProperty.call(o, k); };
  var safeKey = function (v) { v = String(v || '').toLowerCase(); return KEY_RE.test(v) ? v : ''; };
  var scrollBehavior = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; };

  function norm(s) {
    return String(s || '')
      .replace(/[！-～]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); })
      .toLowerCase()
      .replace(/[『』「」（）()\[\]【】\s　・,、/／\-_–—]/g, '');
  }

  function loadMap() {
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-catalog-pdf-map]'), function (el) {
      try { var arr = JSON.parse(el.textContent); if (Array.isArray(arr)) out = out.concat(arr); } catch (e) {}
    });
    return out.filter(function (e) { return e && e.model && e.url; });
  }

  function init(root) {
    if (!root || root.getAttribute('data-sk-cr-init') === '1') return;
    root.setAttribute('data-sk-cr-init', '1');
    var iframe = root.querySelector('[data-sk-cr-iframe]');
    var iframeTemplate = iframe ? iframe.cloneNode(false) : null;
    var formId = root.getAttribute('data-form-id');
    var search = new URLSearchParams(window.location.search);

    var CAT_LABELS = {};
    Array.prototype.forEach.call(root.querySelectorAll('.sk-cr__chip[data-category]'), function (chip) {
      var key = safeKey(chip.getAttribute('data-category'));
      var label = (chip.getAttribute('data-label') || '').trim();
      if (key && label) CAT_LABELS[key] = label;
    });
    var catLabel = function (key) { return hasOwn(CAT_LABELS, key) ? CAT_LABELS[key] : ''; };

    /* 1) URL クエリ → Tally hidden fields */
    var allowed = (root.getAttribute('data-passthrough') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var ctx = {};
    allowed.forEach(function (k) { var v = search.get(k); if (v) ctx[k] = v.slice(0, 200); });
    var defSource = root.getAttribute('data-default-source');
    if (allowed.indexOf('source') > -1 && !ctx.source && defSource) ctx.source = defSource;
    var category = catLabel(safeKey(ctx.category)) ? safeKey(ctx.category) : '';
    if (category) ctx.category = category;
    else delete ctx.category;
    var iframeLoaded = Boolean(iframe && iframe.getAttribute('src'));
    function loadForm(replaceFrame) {
      if (!iframe) return;
      var base = iframe.getAttribute('data-src');
      if (!base) return;
      if (replaceFrame) {
        // 新しい閲覧コンテキストを作り、旧フォームの遅延イベントを送信元比較で除外する。
        // Tallyが付与する初期化済み属性・ID・高さは引き継がず、初回のマークアップから作る。
        var nextFrame = iframeTemplate.cloneNode(false);
        nextFrame.removeAttribute('src');
        try {
          if (iframe.iframeResizer && typeof iframe.iframeResizer.disconnect === 'function') iframe.iframeResizer.disconnect();
        } catch (e) {}
        iframe.parentNode.replaceChild(nextFrame, iframe);
        iframe = nextFrame;
      }
      var qs = allowed.filter(function (k) { return hasOwn(ctx, k) && ctx[k]; }).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(ctx[k]); });
      iframe.src = qs.length ? base + (base.indexOf('?') > -1 ? '&' : '?') + qs.join('&') : base;
      iframeLoaded = true;
      try { if (window.Tally && typeof window.Tally.loadEmbeds === 'function') window.Tally.loadEmbeds(); } catch (e) {}
    }
    if (!iframeLoaded && (!root.classList.contains('has-selector') || ctx.model)) loadForm(false);

    /* 2) 選択中の機種（小ページの「カタログを請求」から来た場合） */
    var picked = root.querySelector('[data-sk-cr-picked]');
    var availability = root.querySelector('[data-sk-cr-availability]');
    var copy = root.querySelector('[data-sk-cr-copy]');
    var copyStatus = root.querySelector('[data-sk-cr-copy-status]');
    var change = root.querySelector('[data-sk-cr-picked-change]');
    var choosePrompt = root.querySelector('[data-sk-cr-choose-prompt]');

    /* 3) 機種→PDF の照合 */
    var includeExternal = root.getAttribute('data-include-external') === 'true';
    var usable = function (e) { return includeExternal || e.host !== 'external'; };
    function findMatches(map, query) {
      var n = norm(query);
      if (!n || map.some(function (e) { return norm(e.maker) === n; })) return [];
      // 部分一致では Ultra / Pro / 周辺機器を別機種へ誤照合するため、明示した別名だけを許可する。
      return map.filter(usable).filter(function (e) {
        return [e.model].concat(e.aliases || []).some(function (key) { return norm(key) === n; });
      });
    }
    root.skCatalogDelivery = function (model) { return findMatches(loadMap(), model).length > 0; };
    function updatePicked() {
      if (picked) {
        var modelEl = picked.querySelector('[data-sk-cr-picked-model]');
        if (modelEl) modelEl.textContent = ctx.model || '';
        var catEl = picked.querySelector('[data-sk-cr-picked-cat]');
        if (catEl) catEl.textContent = catLabel(category) ? '（' + catLabel(category) + '）' : '';
        picked.classList.toggle('is-visible', Boolean(ctx.model) && root.getAttribute('data-sk-cr-submitted') !== '1');
        var chipHref = '#' + root.id;
        Array.prototype.forEach.call(root.querySelectorAll('.sk-cr__chip[data-category]'), function (chip) {
          if (safeKey(chip.getAttribute('data-category')) === category && chip.getAttribute('href')) chipHref = chip.getAttribute('href');
        });
        if (change) change.setAttribute('href', chipHref);
      }
      if (availability) {
        availability.textContent = ctx.model ? root.getAttribute(root.skCatalogDelivery(ctx.model) ? 'data-pdf-ready-text' : 'data-pdf-followup-text') || '' : '';
        if (availability.textContent.trim()) availability.removeAttribute('hidden');
        else availability.setAttribute('hidden', '');
      }
      if (copy) {
        if (ctx.model) copy.removeAttribute('hidden');
        else copy.setAttribute('hidden', '');
      }
      if (copyStatus) copyStatus.textContent = '';
    }
    function showForm() {
      var card = root.querySelector('[data-sk-cr-card]');
      if (!card) return;
      if (card.scrollIntoView) card.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
      card.setAttribute('tabindex', '-1');
      try { card.focus({ preventScroll: true }); } catch (e) {}
    }
    function resetDone() {
      root.removeAttribute('data-sk-cr-submitted');
      var embed = root.querySelector('[data-sk-cr-embed]');
      if (embed) embed.classList.remove('is-done');
      ['[data-sk-cr-done-list]', '[data-sk-cr-more-list]'].forEach(function (selector) {
        var list = root.querySelector(selector); if (list) list.innerHTML = '';
      });
      var lead = root.querySelector('[data-sk-cr-done-lead]'); if (lead) lead.textContent = '';
      var more = root.querySelector('[data-sk-cr-more]');
      if (more) { more.setAttribute('hidden', ''); more.open = false; }
    }
    updatePicked();
    if (root.classList.contains('has-selector') && ctx.model) {
      root.classList.add('has-catalog-choice');
      if (choosePrompt) choosePrompt.setAttribute('hidden', '');
    }
    root.addEventListener('sk:catalog-select', function (e) {
      var choice = e.detail;
      if (!root.classList.contains('has-selector') || !choice || typeof choice.model !== 'string') return;
      var model = choice.model.trim().slice(0, 200);
      var changed = model !== (ctx.model || '');
      if (iframeLoaded && changed && choice.confirmed !== true) return;
      root.classList.add('has-catalog-choice');
      if (choosePrompt) choosePrompt.setAttribute('hidden', '');
      if (iframeLoaded && !changed) { showForm(); return; }
      ctx.model = model;
      category = catLabel(safeKey(choice.category)) ? safeKey(choice.category) : '';
      if (category) ctx.category = category;
      else delete ctx.category;
      ctx.source = 'catalog-selector';
      if (changed && choice.confirmed === true) resetDone();
      loadForm(iframeLoaded && changed);
      updatePicked();
      showForm();
    });
    if (change) change.addEventListener('click', function (e) {
      if (!root.classList.contains('has-selector')) return;
      e.preventDefault();
      root.dispatchEvent(new CustomEvent('sk:catalog-open'));
    });
    if (copy) copy.addEventListener('click', function () {
      if (!ctx.model) return;
      var model = ctx.model;
      function report(success) {
        if (copyStatus && ctx.model === model) copyStatus.textContent = root.getAttribute(success ? 'data-copy-success-text' : 'data-copy-failure-text') || '';
      }
      try {
        if (!window.navigator || !window.navigator.clipboard) { report(false); return; }
        window.navigator.clipboard.writeText(model).then(function () { report(true); }, function () { report(false); });
      } catch (e) { report(false); }
    });
    function pdfRow(e) {
      var meta = [];
      (e.cats || []).forEach(function (c) { var l = catLabel(safeKey(c)); if (l) meta.push(l); });
      meta.push('PDF' + (e.size ? ' ' + e.size : ''));
      if (e.version) meta.push(e.version);
      var external = e.host === 'external';
      var a = document.createElement('a');
      a.className = 'sk-cr__pdf-btn'; a.href = e.url; a.target = '_blank'; a.rel = 'noopener';
      var label = external ? (root.getAttribute('data-download-label') || 'PDFをダウンロード') : (root.getAttribute('data-open-label') || 'PDFを開く');
      a.textContent = external && e.size ? label + '（' + e.size + '）' : label;
      a.setAttribute('aria-label', e.model + ' の' + label + '（新しいタブ）');
      var row = document.createElement('div'); row.className = 'sk-cr__pdf';
      var left = document.createElement('div');
      var name = document.createElement('div'); name.className = 'sk-cr__pdf-name'; name.textContent = e.model;
      var m = document.createElement('div'); m.className = 'sk-cr__pdf-meta'; m.textContent = meta.join(' ・ ');
      left.appendChild(name); left.appendChild(m); row.appendChild(left); row.appendChild(a);
      return row;
    }

    /* 4) 送信後パネル */
    function pickText(v) {
      var arr = Array.isArray(v) ? v : [v];
      for (var i = 0; i < arr.length; i++) { if (typeof arr[i] === 'string' && arr[i].trim()) return arr[i].trim(); }
      return '';
    }
    function renderDone(payload) {
      if (root.getAttribute('data-sk-cr-submitted') === '1') return;
      var embed = root.querySelector('[data-sk-cr-embed]');
      var done = root.querySelector('[data-sk-cr-done]');
      if (!embed || !done) return;
      root.setAttribute('data-sk-cr-submitted', '1');
      var map = loadMap();
      var typed = '', kubun = '';
      try {
        (payload.fields || []).forEach(function (f) {
          var t = String(f.title || '');
          var ans = f.answer || {};
          var candidates = [ans.value, ans.raw];
          /* Tally 実測: hidden field は type HIDDEN_FIELDS・title=フィールド名で届く（URL に無い場合の保険） */
          if (f.type === 'HIDDEN_FIELDS') {
            if (t === 'model' && !ctx.model && typeof ans.value === 'string') ctx.model = ans.value.slice(0, 200);
            if (t === 'category' && !category && catLabel(safeKey(ans.value))) category = safeKey(ans.value);
            return;
          }
          if (t.indexOf('機種') > -1 && !typed) typed = pickText(candidates[0]) || pickText(candidates[1]);
          if (t.indexOf('区分') > -1 && !kubun) {
            candidates.forEach(function (v) {
              var arr = Array.isArray(v) ? v : [v];
              arr.forEach(function (x) { if (typeof x === 'string') KUBUN.forEach(function (k) { if (x.indexOf(k) > -1) kubun = k; }); });
            });
          }
        });
      } catch (e) {}
      // フォームで希望機種を変えた場合は、その入力を正とする。未一致でも古いURLの機種へ戻さない。
      var requestedModel = typed || ctx.model;
      var matches = findMatches(map, requestedModel);
      var inputChanged = typed && norm(typed) !== norm(ctx.model);
      var matchedCategory = (matches[0] && matches[0].cats && safeKey(matches[0].cats[0])) || '';
      var cat = inputChanged ? matchedCategory : category || matchedCategory;
      var list = done.querySelector('[data-sk-cr-done-list]');
      var lead = done.querySelector('[data-sk-cr-done-lead]');
      var more = done.querySelector('[data-sk-cr-more]');
      var moreList = done.querySelector('[data-sk-cr-more-list]');
      var lim = parseInt(root.getAttribute('data-more-limit'), 10); if (isNaN(lim)) lim = 8;
      list.innerHTML = '';
      matches.forEach(function (e) { list.appendChild(pdfRow(e)); });
      var others = [];
      if (cat && lim > 0) {
        others = map.filter(usable).filter(function (e) {
          return matches.indexOf(e) === -1 && (e.cats || []).map(safeKey).indexOf(cat) > -1;
        }).slice(0, lim);
      }
      if (matches.length) lead.textContent = lead.getAttribute('data-text-matched');
      else if (others.length) lead.textContent = lead.getAttribute('data-text-unmatched');
      else lead.textContent = lead.getAttribute('data-text-none');
      if (more && moreList) {
        moreList.innerHTML = '';
        if (others.length) {
          others.forEach(function (e) { moreList.appendChild(pdfRow(e)); });
          var sum = done.querySelector('[data-sk-cr-more-summary]');
          if (sum) sum.textContent = (catLabel(cat) ? catLabel(cat) + 'の' : '') + (sum.getAttribute('data-template') || '他機種のカタログ') + '（' + others.length + '件）';
          more.removeAttribute('hidden');
          more.open = !matches.length;
        } else {
          more.setAttribute('hidden', '');
        }
      }
      if (picked) picked.classList.remove('is-visible');
      embed.classList.add('is-done');
      var card = root.querySelector('[data-sk-cr-card]');
      if (card && card.scrollIntoView) { try { card.scrollIntoView({ behavior: scrollBehavior(), block: 'start' }); } catch (e) { card.scrollIntoView(); } }
      var title = done.querySelector('[data-sk-cr-done-title]');
      if (title) { title.setAttribute('tabindex', '-1'); try { title.focus({ preventScroll: true }); } catch (e) {} }

      /* 5) 計測（定義済みの値のみ。自由入力・個人情報は送らない） */
      var ev = root.getAttribute('data-event-name');
      if (!ev) return;
      var params = {
        form_id: formId,
        catalog_category: cat || '(none)',
        catalog_model: matches.length ? matches[0].model : (requestedModel ? '(unmatched)' : '(none)'),
        customer_type: kubun || '(other)',
        request_source: SOURCES.indexOf(ctx.source) > -1 ? ctx.source : '(other)',
        pdf_matched: matches.length
      };
      try {
        var gaParams = {}; Object.keys(params).forEach(function (k) { gaParams[k] = params[k]; });
        var gaId = root.getAttribute('data-ga-id');
        if (gaId) gaParams.send_to = gaId;
        window.dataLayer = window.dataLayer || [];
        (typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); })('event', ev, gaParams);
      } catch (e) {}
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(ev, params);
        }
      } catch (e) {}
    }

    window.addEventListener('message', function (e) {
      if (!root.isConnected) return;
      if (e.origin !== 'https://tally.so' || typeof e.data !== 'string' || e.data.indexOf('Tally.FormSubmitted') === -1) return;
      if (!iframeLoaded || !iframe || !iframe.contentWindow || e.source !== iframe.contentWindow) return;
      var msg; try { msg = JSON.parse(e.data); } catch (err) { return; }
      if (!msg || msg.event !== 'Tally.FormSubmitted' || !msg.payload || msg.payload.formId !== formId) return;
      renderDone(msg.payload);
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sk-cr]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
